import { render } from "./Globe.vue?vue&type=template&id=c968d962"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Globe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c968d962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c968d962', __exports__)) {
    api.reload('c968d962', __exports__)
  }
  
  module.hot.accept("./Globe.vue?vue&type=template&id=c968d962", () => {
    api.rerender('c968d962', render)
  })

}


export default __exports__